import Api from "../../../services/Api";

function fetchChargerConfig(siteId, chargerId) {
  return Api.get(`/service/iqevse-csms/charger/v1/config/${siteId}/${chargerId}`);
}

export { fetchChargerConfig };
